// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","711":"debug","837":"enigma"}[chunkId] + "." + {"328":"7a678a0b","711":"808d15e4","837":"94a9d8f3"}[chunkId] + ".js";
};